import { useEffect, useState } from 'react';
import { Box, Card, Stack, Typography, IconButton } from '@mui/material';
import Detail from './detail.js'
import dayjs from 'dayjs'
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { useNavigate } from 'react-router-dom';

const IndRow = ({trip}) => {
    const navigate = useNavigate();

    const navToPoi = async() =>{
        const response = await fetch(`/api/trips/${trip._id}/first-poi`)
        const firstTrip = await response.json()
        const path = firstTrip.slug ? `${firstTrip.slug}_${firstTrip._id}` : `${firstTrip.title.toLowerCase().replaceAll(" ", "-")}_${firstTrip._id}` 
        navigate(`/poi/${path}`);
    }
    
    return (
        <Card sx={{mb:2, pl:2, pr:2, pb:3, pt:3, position: 'relative'}}>
            <Stack>
                <Typography>{trip.title}</Typography>
                <Stack direction="row">
                    <Typography sx={{fontSize: 12}}>{dayjs(trip.startDate).format("DD/MM/YYYY")}</Typography>
                    <Typography sx={{fontSize: 12, ml: 2}}>{trip.noOfDays} days</Typography>
                </Stack>
                
            </Stack>
            <IconButton onClick={navToPoi} sx={{position: 'absolute', top:'30%', right: 5}}>
                <ArrowForwardIosIcon/>
            </IconButton>
        </Card>
    )
}

const ListView = ({trips, selectedLoc, setSelectedLoc, isDetailOpen, setIsDetailOpen, lastSelectedLoc, selectedTrip, setSelectedTrip, tripFilter}) => {
    return (
        <Box>
            <div style={{height:'calc(100dvh - 60px)', width:'100%', position:'relative', overflowY:'scroll'}}>
               {trips.map(trip=>(<IndRow key={`trip-${trip._id}`} trip={trip}/>))}
            </div>
            {isDetailOpen && (<Detail
                open={isDetailOpen}
                selectedLoc={selectedLoc}
                setOpen={setIsDetailOpen}
                setSelectedLoc={setSelectedLoc}
                selectedTrip={selectedTrip}
                setSelectedTrip={setSelectedTrip}
                tripFilter={tripFilter}
            />)}
        </Box>
    );
}

export default ListView